import React, { useCallback, useEffect, useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useThemeMode } from '../context/ThemeModeContext';
import { apiGet } from '../api';
import { Icon, Modal } from './ui';
import packageJson from '../../package.json';

export const APP_VERSION = packageJson.version;

const NAV_ITEMS = [
  { label: 'ภาพรวม', path: '/dashboard' },
  { label: 'จัดการไฟล์', path: '/files', unknownBadge: true },
  { label: 'ตารางส่ง', path: '/schedule' },
  { label: 'ตั้งค่า', path: '/settings' },
];

const UNKNOWN_POLL_MS = 30000;

export default function Layout({ children }) {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const { mode, toggleMode } = useThemeMode();
  const [confirmOut, setConfirmOut] = useState(false);
  const [unknownCount, setUnknownCount] = useState(0);

  const loadUnknown = useCallback(async () => {
    try {
      const data = await apiGet('/api/files/unknown');
      setUnknownCount(data.count || 0);
    } catch (e) { /* ไม่ใช่เรื่องใหญ่ — แค่ป้ายบนแท็บ */ }
  }, []);

  useEffect(() => {
    loadUnknown();
    const t = setInterval(loadUnknown, UNKNOWN_POLL_MS);
    window.addEventListener('ttnbcp:unknown-changed', loadUnknown);
    return () => { clearInterval(t); window.removeEventListener('ttnbcp:unknown-changed', loadUnknown); };
  }, [loadUnknown]);

  const doLogout = async () => {
    setConfirmOut(false);
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <>
      <header className="topbar">
        <div className="topbar-inner">
          <Link to="/dashboard" className="brand">
            <span className="wordmark">TTNBCP</span>
            <span className="brand-sub">BCP Dashboard</span>
            <span className="ver">v{APP_VERSION}</span>
          </Link>
          <div className="topbar-right">
            <nav className="tabs">
              {NAV_ITEMS.map((item) => (
                <NavLink key={item.path} to={item.path} className={({ isActive }) => `tab${isActive ? ' active' : ''}`}>
                  {item.label}
                  {item.unknownBadge && unknownCount > 0 && (
                    <span className="badge" title={`${unknownCount} ไฟล์ค้างใน UNKNOW`}>{unknownCount}</span>
                  )}
                </NavLink>
              ))}
            </nav>
            <span className="vsep" />
            <button className="icon-btn" onClick={toggleMode}
              title={mode === 'dark' ? 'เปลี่ยนเป็นโหมดสว่าง' : 'เปลี่ยนเป็นโหมดมืด'}
              aria-label={mode === 'dark' ? 'เปลี่ยนเป็นโหมดสว่าง' : 'เปลี่ยนเป็นโหมดมืด'}>
              <Icon name={mode === 'dark' ? 'sun' : 'moon'} />
            </button>
            <div className="user">
              <div className="avatar">{(user || '?').slice(0, 1)}</div>
              <span className="name">{user}</span>
            </div>
            <button className="logout-btn" onClick={() => setConfirmOut(true)}>ออกจากระบบ</button>
          </div>
        </div>
      </header>

      <main className="page">{children}</main>

      <Modal open={confirmOut} title="ออกจากระบบ" onClose={() => setConfirmOut(false)}
        actions={(
          <>
            <button className="btn btn-outline" onClick={() => setConfirmOut(false)}>ยกเลิก</button>
            <button className="btn btn-primary" onClick={doLogout}>ออกจากระบบ</button>
          </>
        )}>
        <p>ครั้งถัดไปต้องเข้าสู่ระบบและกรอกรหัสยืนยันตัวตนใหม่</p>
      </Modal>
    </>
  );
}
